import { Form } from 'factorial-form'

class IrpfForm extends Form {
  constructor(values: Record<string, unknown>) {
    super(values, {
      country_metadata: {
        irpf_in_cents: 'cents',
      },
    })
  }
}

export default IrpfForm
